import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import setupInterceptors from './services/setupInterceptors';
// import { StyledEngineProvider } from '@mui/material/styles';
// import { CssBaseline } from '@mui/material';

ReactDOM.render(
  // <StyledEngineProvider injectFirst>
  <Provider store={store}>
    {/* <BrowserRouter> */}
    {/* <CssBaseline /> */}
    <App />
    {/* </BrowserRouter> */}
  </Provider>,
  document.getElementById('root')
);

setupInterceptors(store);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
